import React, { useEffect, useState } from "react";
import { closestCenter, DndContext, KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { mdiPlus } from "@mdi/js";
import CreateNewStageDialog from "../components/CreateNewStageDialog";
import { Button, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import useAxios from "../../../hooks/useAxios";
import Icon from "@mdi/react";
import { useSnackbar } from "../../../components/context/SnackbarContext";
import DraggableTableRow from '../components/DraggableTableRow'
import TablePagination from "@mui/material/TablePagination";
import { useSelector } from "react-redux";
function LeadStages({ leadData, handleReloadFunc, perPage, currentPage, totalCount, handlePageChange, handleRowsPerPageChange }) {

    const [leadStages, setLeadStages] = useState(leadData || []);
    const axiosInstance = useAxios();
    const { showSnackbar } = useSnackbar();
    const [leadPosition, setLeadPosition] = useState();
    const isUsedValue = "lead";
    const userPermissions = useSelector((state) => state.user.permission);
    useEffect(() => {
        setLeadStages(leadData || []);
    }, [leadData]);

    const [createNewStageDialogOpen, setCreateNewStageDialogOpen] = React.useState(false);
    const openCreateNewStageDialog = () => {
        getPositionData();
        setCreateNewStageDialogOpen(true);
    }
    const closeCreateNewStageDialog = () => {
        setCreateNewStageDialogOpen(false);
    }

    const sensors = useSensors(
        useSensor(MouseSensor, {}),
        useSensor(TouchSensor, {}),
        useSensor(KeyboardSensor, {})
    );

    const handleDragEnd = async (event) => {
        const { active, over } = event;

        if (active.id !== over.id) {
            const oldIndex = items.indexOf(active.id);
            const newIndex = items.indexOf(over.id);
            const updatedLeadStages = arrayMove(leadStages, oldIndex, newIndex);

            setLeadStages(updatedLeadStages);

            const finalList = updatedLeadStages.map(stage => stage.name);
            const payload = {
                finalList,
                is_position_change: true,
                is_used: "lead"
            };

            try {
                const response = await axiosInstance.post('/api/stage/update', payload);
                if (response.status === 200) {
                    showSnackbar(response.data.message, 'success');
                } else {
                    showSnackbar('Unexpected response status', 'warning');
                }
            } catch (error) {
                showSnackbar('Failed to update stages', 'error');
            }
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getPositionData = async () => {
        try {
            const leadPositionResponse = await axiosInstance.get('api/stage/create');
            if (leadPositionResponse.status === 200) {
                setLeadPosition(leadPositionResponse.data.data.latestLeadPosition);
            }
            else {
                showSnackbar('Unexpected response status', 'warning');
            }

        } catch (error) {
            if (error.response) {
                if (error.response.status === 300 || error.response.status === 400) {
                    showSnackbar(error.response.data.message, "warning");
                }
            }
        }
    };

    const items = React.useMemo(() => leadStages?.map((stage) => stage.id) || [], [leadStages]);


    return (
        <>
            <div className="card-header">
                <h6 className="title">Lead Stages</h6>
                {userPermissions && userPermissions.includes("stage_create") &&
                    <Button color="secondary" size="small" className="action" onClick={openCreateNewStageDialog}>
                        <span>
                            <Icon path={mdiPlus} color={'currentColor'} size={1} />
                            <span>Add</span>
                        </span>
                    </Button>
                }
            </div>

            <DndContext
                sensors={sensors}
                onDragEnd={handleDragEnd}
                collisionDetection={closestCenter}
                modifiers={[restrictToVerticalAxis]}
            >
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell width={10}></TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell align="center">Active</TableCell>
                            <TableCell width={10}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {leadStages && leadStages.length > 0 && (
                            <SortableContext items={items} strategy={verticalListSortingStrategy}>
                                {leadStages.map((stage, i) => {
                                    return <DraggableTableRow key={stage.id + ''} row={stage} handleReloadFunc={handleReloadFunc} />;
                                })}
                            </SortableContext>
                        )}
                    </TableBody>
                </Table>
            </DndContext>

            {
                leadStages && leadStages.length > 0 &&
                <TablePagination
                    className="mt-16"
                    component="div"
                    count={totalCount}
                    page={currentPage}
                    rowsPerPage={perPage}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPageChange}
                />
            }

            <CreateNewStageDialog open={createNewStageDialogOpen} onClose={closeCreateNewStageDialog} handleReloadFunc={handleReloadFunc} position={leadPosition} isUsed={isUsedValue} />
        </>
    );
}


export default LeadStages;